import { render, staticRenderFns } from "./AdditionalProduct_duration_yareto.vue?vue&type=template&id=d7184bce&scoped=true"
import script from "./AdditionalProduct_duration_yareto.vue?vue&type=script&lang=js"
export * from "./AdditionalProduct_duration_yareto.vue?vue&type=script&lang=js"
import style0 from "./AdditionalProduct_duration_yareto.vue?vue&type=style&index=0&id=d7184bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7184bce",
  null
  
)

export default component.exports